import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcCinemaCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 6v4.612l6-2v14.775l-6-2V26H2V6h22Zm-2 2H4v16h18V8Zm6 3.387-4 1.333v6.559l4 1.333v-9.225Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcCinemaCamera;
